/**
 *
 * @param organization Object.
 * @param plantId null || int.
 * @description returns all the monitorables of a given organization or a specific plant
 * @returns {Array}
 */
export function getMonitorables(organization, plantId) {
  const monitorables = [];

  if (plantId) {
    // Just get the monitorables of plant
    let plant = null;
    organization.plants.forEach((p) => {
      if (p.id == plantId) {
        plant = p;
      }
    });

    plant.sections.forEach((section) => {
      section.monitorables.forEach((monitorable) => {
        monitorable.plant = {
          name: plant.name,
          id: plant.id,
        };
        monitorable.section = {
          name: section.name,
          id: section.id,
        };
        monitorable.organization = {
          name: organization.name,
          id: organization.id,
        };
        monitorables.push(monitorable);
      });
    });
  } else {
    // All monitorables
    organization.plants.forEach((plant) => {
      plant.sections.forEach((section) => {
        section.monitorables.forEach((monitorable) => {
          monitorable.plant = {
            name: plant.name,
            id: plant.id,
          };
          monitorable.section = {
            name: section.name,
            id: section.id,
          };
          monitorable.organization = {
            name: organization.name,
            id: organization.id,
          };
          monitorables.push(monitorable);
        });
      });
    });
  }

  return monitorables;
}

/**
 * Returns an array of monitorables that are not additional monitorables. (like weather)
 * @param monitorables
 * @param additionalMonitorables
 * @returns {Array}
 */
export function getMonitorablesWithoutAdditionals(
  monitorables,
  additionalMonitorables,
) {
  const additionalMonitorableIds = additionalMonitorables.map(adM => adM.id);
  return monitorables.filter(
    monitorable => !additionalMonitorableIds.includes(monitorable.id),
  );
}

/**
 * Returns the monitorables of a certain service
 * @param monitorables
 * @param serviceId
 */
export function filterMonitorablesByService(monitorables, serviceId) {
  const auxMonitorables = [];
  monitorables.forEach((monitorable) => {
    if (monitorable.service == serviceId || monitorable.type.id=="VUELOSAIC") {
      auxMonitorables.push(monitorable);
    }
  });

  return auxMonitorables;
}

export function filterCo2Monitorable(m) {
  let co2Mons = [];
  m.forEach(element => {
    if (element.type.id == "URAM102") {
      //tipo URAM102 y ademas tiene variable co2 PARTICULADO
      for (let i = 0; i < element.variables.length; i++) {
        let vari = element.variables[i];
        if (vari.type.id == "PARTICULADO" && vari.name == "CO2") {
          co2Mons.push(element);
          break;
        }
      }
    }
  });

  return co2Mons;
}

/**
 * Get all the variables from an array of monitorables
 * @param monitorables
 * @returns {Array}
 */
export function getVariables(monitorables) {
  const variables = [];
  monitorables.forEach((monitorable) => {
    monitorable.variables.forEach((variable) => {
      variable.monitorable = {
        name: monitorable.name,
        id: monitorable.id,
      };
      variable.plant = monitorable.plant;
      variable.section = monitorable.section;
      variables.push(variable);
    });
  });

  return variables;
}

/**
 * Get the plants of a certain organization, without sections
 * @param organization
 * @returns {Array}
 */
export function getPlants(organization) {
  const plants = [];

  organization.plants.forEach((plant) => {
    plants.push({
      address: plant.address,
      city: plant.city,
      id: plant.id,
      name: plant.name,
      phone: plant.phone,
      postalCode: plant.postalCode,
      timeZone: plant.timeZone,
      sections: plant.sections,
      coldReferenceTemperature: plant.coldReferenceTemperature,
      hotReferenceTemperature: plant.hotReferenceTemperature,
      idMeteoStation: plant.idMeteoStation
    });
  });

  return plants;
}

export function getSections(organization, plantIndex) {
  let sections = [];
  if (plantIndex == -1) {
    organization.plants.forEach((plant) => {
      plant.sections.forEach((section) => {
        section.plant = { id: plant.id, name: plant.name };
        sections.push(section);
      });
    });
  } else {
    sections = organization.plants[plantIndex].sections.map((section) => {
      section.plant = {
        id: organization.plants[plantIndex].id,
        name: organization.plants[plantIndex].name,
      };
      return section;
    });
  }

  return sections;
}

/**
 *
 * @param monitorables
 * @param typeId
 * @returns {*}
 */
export function filterMonitorablesByType(monitorables, typeId) {
  const auxMonitorables = [];
  monitorables.forEach((monitorable) => {
    if (typeId === 'ALL' || monitorable.type.id === typeId) {
      auxMonitorables.push(monitorable);
    }
  });

  return monitorables;
}

/**
 * Returns an array of variables given variable ids.
 * @param variables
 * @param variableIds
 * @returns {*}
 */
export function getVariablesWithIds(variables, variableIds) {
  const auxVariables = [];
  variableIds = variableIds.map(Number);

  variables.forEach((variable) => {
    if (variableIds.includes(variable.id)) {
      auxVariables.push(variable);
    }
  });

  return auxVariables;
}

/**
 * Adds variables Objects to process
 * @param variables
 * @param processes
 * @returns {*}
 */
export function getProcesses(variables, processes) {
  if (processes.length > 0) {
    for (const process in processes) {
      processes[process].variables = getVariablesWithIds(
        variables,
        processes[process].idsVariables,
      );
    }
  }

  return processes;
}

export function getVariablesForIndicatorId(allVariables, indicatorId) {
  if (indicators.length > 0) {
    for (const indicator in indicators) {
      indicators[indicator].variablesList = [];

      for (const variable in indicators[indicator].variables) {
        const newVariable = getVariablesWithIds(variables, [
          indicators[indicator].variables[variable].id,
        ])[0];

        const isInArray = indicators[indicator].variablesList.find(
          item => item.id === newVariable.id,
        );

        if (!isInArray) {
          indicators[indicator].variablesList.push(newVariable);
        }
      }
    }
  }

  return indicators;
}

export function getIndicators(variables, indicators) {
  if (indicators.length > 0) {
    for (const indicator in indicators) {
      indicators[indicator].variablesList = [];

      for (const variable in indicators[indicator].variables) {
        const newVariable = getVariablesWithIds(variables, [
          indicators[indicator].variables[variable].id,
        ])[0];

        const isInArray = indicators[indicator].variablesList.find(
          item => item.id === newVariable.id,
        );

        if (!isInArray) {
          indicators[indicator].variablesList.push(newVariable);
        }
      }
    }
  }

  return indicators;
}

export function filterMonitorablesOfId(monitorables, monitorableIds) {
  const auxMonitorables = [];
  monitorables.forEach((auxMonitorable) => {
    if (monitorableIds.includes(auxMonitorable.id)) {
      auxMonitorables.push(auxMonitorable);
    }
  });

  return auxMonitorables;
}

export function getAllVariablesFromMonitorables(monitorables, monitorableIds) {
  const filteredMonitorables = filterMonitorablesOfId(
    monitorables,
    monitorableIds,
  );
  let variables = [];
  filteredMonitorables.forEach((auxMonitorable) => {
    variables = variables.concat(auxMonitorable.variables);
  });

  return variables;
}

/**
 * Return an array of monitorable ids given an array of variable ids.
 * @param monitorables
 * @param variableIds
 * @returns {*}
 */
export function getMonitorableIdsWithVariableIds(monitorables, variableIds) {
  const monitorablesIds = [];
  variableIds = variableIds.map(String);
  monitorables.forEach((monitorable) => {
    monitorable.variables.forEach((variable) => {
      if (
        variableIds.includes(variable.id.toString()) &&
        !monitorablesIds.includes(monitorable.id.toString())
      ) {
        monitorablesIds.push(monitorable.id);
      }
    });
  });

  return monitorablesIds;
}

export function getTurns(organization) {
  let turns = organization.turns;

  if (!Array.isArray(turns)) {
    // Don't remember why this statement.
    turns = [];
  }

  return turns;
}

export function getVariableOfId(variables, variableId) {
  // Ensure we are passing an array.
  if (!Array.isArray(variableId)) {
    variableId = [variableId];
  }
  const variable = getVariablesWithIds(variables, variableId);
  if (variable.length === 1) {
    return variable[0];
  }
  return null;
}

export function getAlerts(alerts, organization) {
  const auxAlerts = [];

  alerts.forEach((alert) => {
    if (alert.idOrganization === organization.id) {
      if ( alert.isActive ) {
        alert.key = alert.id;
        auxAlerts.push(alert);
      }
    }
  });

  return auxAlerts;
}

export function getPlantOfId(plants, plantId) {
  let plant;
  plants.forEach((p) => {
    if (p.id === plantId) {
      plant = p;
    }
  });
  return plant;
}

export function getSectionOfId(sections, sectionId) {
  let section;
  sections.forEach((s) => {
    if (s.id === sectionId) {
      section = s;
    }
  });
  return section;
}

export function getMonitorableOfId(monitorables, monitorableId) {
  let monitorable;
  monitorables.forEach((m) => {
    if (m.id === monitorableId) {
      monitorable = m;
    }
  });
  return monitorable;
}

/**
 * Return an array with each alarm's Id and an array with the name of the variable and the monitoreable
 * @param alert
 * @returns {array} 
 */
export function getVariablesOfAlerts(alerts, variables) {
  let arrayWithAlertIdAndVariables = []
  alerts.forEach(alert => {
    let alertWithVariables = {}
    let vars = []
    alertWithVariables.alertId = alert.id
    if (alert.rules.length > 0) {
      alert.rules.forEach(rule => {
        const variableId = rule.idVariable;
        const variableById = getVariableOfId(variables,[variableId])
        if(variableById){
          const nameOfVariable = variableById.name
          const nameMonitoreableOfVariable = variableById.monitorable.name
          vars.push({
            variableName:nameOfVariable,
            monitorableOfvariable:nameMonitoreableOfVariable 
          })
        }
      })
      alertWithVariables.variablesOfAlert = vars
    }
    arrayWithAlertIdAndVariables.push(alertWithVariables)
  })
  return arrayWithAlertIdAndVariables;
}



// WEBPACK FOOTER //
// ./lib/organizationUtils.js